import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import StickyNewsletterBar from "@/components/StickyNewsletterBar";
import Footer from "@/components/Footer";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import Polls from "@/pages/Polls";
import Privacidad from "@/pages/Privacidad";
import Comunicados from "@/pages/Comunicados";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Header />
          <StickyNewsletterBar />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/categoria/:slug" element={<Category />} />
              <Route path="/articulo/:id" element={<Article />} />
              <Route path="/encuestas" element={<Polls />} />
              <Route path="/privacidad" element={<Privacidad />} />
              <Route path="/comunicados" element={<Comunicados />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
